import { ItemResponse } from 'common/types'
import { BetterIDTrayScrew } from 'views/SPDLayout/SPD/SPD.types'

export interface EditTrayModalProps {
  open: boolean
  onClose: () => void
  trayData: ItemResponse
}

export interface TrayStatusDetails {
  rejectionReason?: string
  isRejected?: boolean
  rejectedBy?: string
  rejectedAt?: string
  isApproved?: boolean
  approvedBy?: string
  approvedAt?: string
  lastUpdatedBy?: string
  lastUpdatedAt?: string
}

export type TrayStatus =
  | 'approved'
  | 'rejected'
  | 'canceled'
  | 'readyForPickup'
  | 'caseComplete'
  | 'assigned'
  | 'readyToFill'
  | 'droppedOff'
  | 'unAssigned'
  | 'checkedOut'
  | 'loaded'
  | undefined

export type TrayType =
  | 'stryker screw caddy'
  | 'stryker upper face'
  | 'stryker middle face'
  | 'zimmer curved rods'
  | 'zimmer adjustable transverse connector'
  | 'zimmer standard closure tops'
  | 'zimmer biomet vitality polyaxial screw caddy'
  | '2.0 mini monster'
  | '2.5 mini monster'
  | '3.0 mini monster'
  | 'headless compression screw rack'
  | 'quickfix cannulated screw system'
  | 'mini frag tray rack 4 main (plates)'
  | 'mini frag tray rack 4 top (plates)'
  | 'mini frag tray rack 2 top (plates)'
  | 'maxan anterior cervical plate system 1 level plates caddy'
  | 'maxan anterior cervical plate system 2 level plates caddy'
  | 'maxan anterior cervical plate system 3 level plates caddy'
  | 'maxan anterior cervical plate system screw caddy'
  | 'alif trial set'
  | 'hedron ia locking screws'
  | '24x30mm spacers'
  | '26x34mm spacers'
  | '29x39mm spacers'
  | 'lumbar anchor set'
  | 'instrument'
  | 'zimmer extra space test'
  | 'custom implants'
  | 'stryker 2.0 mp plates upper tray'
  | 'stryker 2.0 mp plates lower tray'
  | 'kls martin 1.5mm lindorf orthognathic module subtray 1'
  | 'kls martin 1.5mm lindorf orthognathic module subtray 2'
  | 'kls martin 1.5mm micro module regular trauma pcoms'
  | 'kls martin 2.0 micro module regular trauma pcoms'
  | 'globus xtend cervical plate set'
  | 'globus xtend screw set'
  | undefined

export const trayStatusDisplayMap: Partial<
  Record<Exclude<TrayStatus, undefined>, string>
> = {
  approved: 'Approved',
  rejected: 'Rejected',
  canceled: 'Canceled',
  readyForPickup: 'Ready For Pickup',
  caseComplete: 'Case Completed/ Dirty',
  assigned: 'Assigned',
  readyToFill: 'Ready To Fill',
  droppedOff: 'Dropped Off',
  unAssigned: 'Unassigned',
  checkedOut: 'Checked Out',
  loaded: 'Loaded/Ready To Assign',
}

export interface UseEditTrayModalProps {
  trayData: ItemResponse
  trayScrews?: BetterIDTrayScrew[]
}
